// 120 AdSense-safe quiz categories for QuizzyLoot.
// CONTENT POLICY: every topic here is general-knowledge / educational trivia.
// Deliberately NO crypto, NFTs, stock/forex/trading, gambling, betting,
// lottery, alcohol/tobacco/drugs, weapons, adult or other restricted themes.
//
// This is a FREE, for-fun trivia game. We intentionally do NOT fabricate a
// real-money contest: no prize pools, no entry fees, no fake live-player counts,
// no winner countdowns. Each category only carries a title, emoji and gradient.

// Gradient class strings (safelisted in tailwind.config.js).
const GRADIENTS = [
  'from-violet-500 to-fuchsia-500',
  'from-sky-500 to-blue-600',
  'from-emerald-500 to-teal-600',
  'from-pink-500 to-rose-500',
  'from-amber-500 to-orange-600',
  'from-indigo-500 to-purple-600',
  'from-red-500 to-rose-600',
  'from-cyan-500 to-sky-600',
  'from-lime-500 to-green-600',
  'from-fuchsia-500 to-purple-600',
  'from-teal-500 to-cyan-600',
  'from-blue-500 to-indigo-600',
  'from-orange-500 to-amber-600',
  'from-rose-500 to-pink-600',
];


// [title, emoji] seeds — all family-friendly trivia themes.
const SEEDS = [
  ['General Knowledge', '🧠'], ['Science', '🔬'], ['World History', '🏛️'], ['Geography', '🗺️'],
  ['Sports', '🏆'], ['Movies', '🎬'], ['Music', '🎵'], ['Animals', '🐾'],
  ['Space & Astronomy', '🚀'], ['Nature', '🌿'], ['Food & Cooking', '🍳'], ['Technology', '💻'],
  ['Mathematics', '➗'], ['Physics', '⚛️'], ['Chemistry', '🧪'], ['Biology', '🧬'],
  ['World Capitals', '🏙️'], ['Flags of the World', '🚩'], ['Famous Landmarks', '🗽'], ['Inventions', '💡'],
  ['Mythology', '🐉'], ['Ancient Civilizations', '🏺'], ['Dinosaurs', '🦕'], ['Oceans & Seas', '🌊'],
  ['Mountains', '⛰️'], ['Rivers & Lakes', '🏞️'], ['Weather & Climate', '🌦️'], ['Plants & Trees', '🌳'],
  ['Birds', '🦜'], ['Insects', '🐞'], ['Famous Scientists', '👩‍🔬'], ['The Olympics', '🥇'],
  ['Football', '⚽'], ['Cricket', '🏏'], ['Basketball', '🏀'], ['Tennis', '🎾'],
  ['Chess', '♟️'], ['Board Games', '🎲'], ['Video Games', '🎮'], ['Cartoons', '🧸'],
  ['Disney', '🏰'], ['Superheroes', '🦸'], ['TV Shows', '📺'], ['Sitcoms', '😂'],
  ['Bollywood', '🎭'], ['Hollywood', '🌟'], ['World Cinema', '🎥'], ['Pop Music', '🎤'],
  ['Rock Music', '🎸'], ['Classical Music', '🎻'], ['Musical Instruments', '🥁'], ['Painting & Art', '🎨'],
  ['Photography', '📷'], ['Architecture', '🏗️'], ['Fashion', '👗'], ['World Languages', '🗣️'],
  ['Grammar', '✏️'], ['Vocabulary', '📖'], ['Idioms & Proverbs', '💬'], ['Riddles', '🤔'],
  ['Logic Puzzles', '🧩'], ['Brain Teasers', '🧠'], ['Pop Culture', '🌐'], ['Books & Authors', '📚'],
  ['Poetry', '🪶'], ['Shakespeare', '🎭'], ['Fairy Tales', '🧚'], ['Comics', '💥'],
  ['Anime', '🎌'], ['Planets', '🪐'], ['Stars & Constellations', '✨'], ['Robotics', '🤖'],
  ['Gadgets', '📱'], ['Computers', '🖥️'], ['Famous Buildings', '🏢'], ['Bridges', '🌉'],
  ['Castles', '🏯'], ['Museums', '🖼️'], ['Festivals', '🎉'], ['World Holidays', '🎄'],
  ['World Cuisines', '🍜'], ['Desserts', '🍰'], ['Fruits', '🍎'], ['Vegetables', '🥦'],
  ['Spices & Herbs', '🌶️'], ['Tea & Coffee', '☕'], ['Gardening', '🪴'], ['Farming', '🚜'],
  ['Ecology', '♻️'], ['Renewable Energy', '🔋'], ['Volcanoes', '🌋'], ['Earthquakes', '🌍'],
  ['Gemstones', '💎'], ['Periodic Table', '⚗️'], ['Human Body', '🫀'], ['Health & Fitness', '🏃'],
  ['Yoga', '🧘'], ['Psychology', '🧩'], ['Philosophy', '🤓'], ['Countries & Nations', '🌎'],
  ['US States', '🦅'], ['European Countries', '🏰'], ['Asian Countries', '🏯'], ['African Wildlife', '🦁'],
  ['Sea Creatures', '🐠'], ['Famous Explorers', '🧭'], ['Kings & Queens', '👑'], ['World Leaders', '🎙️'],
  ['Space Missions', '🛰️'], ['Transportation', '🚗'], ['Trains', '🚆'], ['Aircraft', '✈️'],
  ['Ships & Boats', '🚢'], ['Classic Cars', '🏎️'], ['World Wonders', '🗿'], ['National Parks', '🏕️'],
  ['Deserts', '🏜️'], ['Rainforests', '🌴'], ['Famous Quotes', '💭'], ['Trivia Mix', '🎯'],
];

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const used = new Set();
export const CATEGORIES = SEEDS.map(([title, emoji], i) => {
  let id = slug(title);
  if (used.has(id)) id = `${id}-${i}`;
  used.add(id);
  return {
    id,
    title,
    emoji,
    gradient: GRADIENTS[i % GRADIENTS.length],
  };
});
